module.exports = __webpack_public_path__ + "static/media/PhD.b50a4887.pdf";